import styled from 'styled-components';

export const ModalContent = styled.div.attrs(() => ({
  className: `p-5`,
}))`
  margin-top: 3rem;
`;
